export const ORGANIZATIONS_RECEIVED = 'ORGANIZATIONS_RECEIVED'
export const ORGANIZATION_RECEIVED = 'ORGANIZATION_RECEIVED'
export const UPDATING_ORGANIZATION = 'UPDATING_ORGANIZATION'

export const updateOrganization = payload => ({
  type: UPDATING_ORGANIZATION,
  payload: payload,
})
